// apps/app/src/lib/ui-store.ts
//
// Per-browser interface preferences. Only conveniences live here — losing them
// (private window, cleared storage) must never break anything.

import { create } from 'zustand';

const STORAGE_KEY = 'skinvizo.ui';

interface UiState {
  sidebarCollapsed: boolean;
  toggleSidebar(): void;
}

function read(): Partial<UiState> {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) ?? '{}') as Partial<UiState>;
  } catch {
    return {};
  }
}

function write(state: Pick<UiState, 'sidebarCollapsed'>): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch {
    // Storage blocked: the preference simply does not survive a reload.
  }
}

export const useUi = create<UiState>((set, get) => ({
  sidebarCollapsed: read().sidebarCollapsed === true,
  toggleSidebar() {
    const sidebarCollapsed = !get().sidebarCollapsed;
    write({ sidebarCollapsed });
    set({ sidebarCollapsed });
  },
}));
